var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileUploadVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 68.15,
    viewBox: "0 0 62 68.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    opacity: 0.746
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M46.447,29.5V16.6a1.493,1.493,0,0,0-.412-.98L31.575.44A1.441,1.441,0,0,0,30.539,0H7.613A7.638,7.638,0,0,0,0,7.684V51.035a7.59,7.59,0,0,0,7.613,7.628h18.1A19.533,19.533,0,1,0,46.447,29.5ZM31.959,4.986,41.66,15.2H35.368a3.431,3.431,0,0,1-3.409-3.423ZM7.613,55.821a4.759,4.759,0,0,1-4.772-4.787V7.684A4.8,4.8,0,0,1,7.613,2.841h21.5v8.934a6.262,6.262,0,0,0,6.25,6.264h8.238V29.132c-.426-.014-.767-.057-1.136-.057a19.819,19.819,0,0,0-12.954,4.886H11.477a1.42,1.42,0,1,0,0,2.84h15.4a22.6,22.6,0,0,0-2.5,4.4h-12.9a1.42,1.42,0,1,0,0,2.841H23.451A19.494,19.494,0,0,0,24.3,55.836H7.613Zm34.843,9.5a16.69,16.69,0,1,1,16.689-16.69A16.707,16.707,0,0,1,42.456,65.324Zm0,0",
    fill: "#009639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M76.971,204.525H91.36a1.42,1.42,0,1,0,0-2.841H76.971a1.42,1.42,0,1,0,0,2.841Zm0,0",
    transform: "translate(-65.494 -174.838)",
    fill: "#009639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M256.338,283.665a1.41,1.41,0,0,0-2.074,0l-8.324,8.934a1.415,1.415,0,0,0,.071,2,1.45,1.45,0,0,0,2.031-.071l5.881-6.292V303.75a1.42,1.42,0,0,0,2.841,0V288.239l5.837,6.292a1.417,1.417,0,0,0,2.074-1.932Zm0,0",
    transform: "translate(-212.874 -245.514)",
    fill: "#009639"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadVector);
export default __webpack_public_path__ + "static/media/FileUploadVector.0f05c0f4a7ceb1bd958b7374da3a5fbd.svg";
export { ForwardRef as ReactComponent };